import { makeStyles, Toolbar, withWidth } from "@material-ui/core";
import React from "react";
import classnames from "classnames";

interface Props {
  children: React.ReactNode;
  width: "xs" | "sm" | "md" | "lg" | "xl";
}

const useStyles = makeStyles(
  (theme) => ({
    toolbar: {
      backgroundColor:
        theme.palette.type === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[900],
    },
    desktopToolbar: {
      marginTop: theme.spacing(2),
    },
    mobileToolbar: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      padding: "16px",
      width: "100%",
      boxSizing: "border-box",
      flexShrink: 0,
      zIndex: 2,
    },
    defaultToolbar: {
      flex: 1,
      display: "flex",
      justifyContent: "space-between",
    },
    spacer: {
      [theme.breakpoints.down("xs")]: {
        height: "5em",
      },
    },
  }),
  { name: "RaToolbar" }
);

export const CompactFormToolbar = withWidth({ initialWidth: "xs" })(
  ({ children, width, ...rest }: Props) => {
    const classes = useStyles();
    return (
      <Toolbar
        className={classnames(classes.toolbar, classes.defaultToolbar, {
          [classes.mobileToolbar]: width === "xs",
          [classes.desktopToolbar]: width !== "xs",
        })}
        role="toolbar"
        {...rest}>
        {children}
      </Toolbar>
    );
  }
);
